import * as React from 'react'
import * as classnames from 'classnames'

import { Site } from '@envato/foundation-types'
import { ISuggestion } from './suggestionsListItem'

import { reportAutoSuggest } from '../../../../common/analytics/searchBarAnalytics'
import FeatureContainer from '../../../containers/feature'
import SearchIcon from '../../../components/icons/search'
import SuggestionsList from './suggestionsList'

interface IProps {
  suggestions: ISuggestion[]
  onInputChange: () => void
  placeholder: string
  onSelectOption: () => void
  inputName: string
  inputValue: string
  type: string
  styles: any
  currentSite: Site
  isOpen: boolean
  ariaLabel: string
  setWrapperRef: () => void
  setTextInputRef: () => void
  handleInputChange: () => void
  handleInputFocus: () => void
  handleKeyDown: () => void
  handleKeyUp: () => void
  focusedIndex: number
  textInputRef: HTMLInputElement
  wrapperRef: HTMLDivElement
  setMenuRef: React.LegacyRef<HTMLDivElement>
  onMenuClick: () => void
  handleMenuMouseEnter: () => void
  handleMenuMouseLeave: () => void
}

const AutoSuggest = (props: IProps) => {
  const {
    isOpen,
    inputValue = '',
    currentSite,
    suggestions,
    inputName,
    placeholder,
    type,
    ariaLabel,
    styles,
    setWrapperRef,
    setTextInputRef,
    handleInputChange,
    handleInputFocus,
    handleKeyDown,
    handleKeyUp,
    focusedIndex,
    textInputRef,
    wrapperRef,
    setMenuRef,
    onMenuClick,
    handleMenuMouseEnter,
    handleMenuMouseLeave
  } = props

  const inputStyle = {
    borderRadius: isOpen && suggestions.length ? '7px 0 0 0' : '7px 0 0 7px'
  }

  const buttonStyle = {
    borderRadius: isOpen && suggestions.length ? '0 7px 0 0' : '0 7px 7px 0'
  }

  const newInputStyle = {
    borderRadius: isOpen && suggestions.length ? '8px 8px 0 0' : '8px'
  }

  return (
    <div
      ref={setWrapperRef}
      className={styles.mainWrapper}
      data-test-selector="autosuggest"
    >
      <FeatureContainer name="!homepageNewDesign">
        <input
          ref={setTextInputRef}
          className={styles.input}
          style={inputStyle}
          placeholder={placeholder || ''}
          autoComplete="off"
          type={type || 'search'}
          aria-label={ariaLabel || 'search'}
          name={inputName || ''}
          value={inputValue}
          onChange={handleInputChange}
          onFocus={handleInputFocus}
          onKeyDown={handleKeyDown}
          onKeyUp={handleKeyUp}
        />
      </FeatureContainer>
      <FeatureContainer name="homepageNewDesign">
        <input
          ref={setTextInputRef}
          className={styles.input}
          style={newInputStyle}
          placeholder={placeholder || ''}
          autoComplete="off"
          type={type || 'search'}
          aria-label={ariaLabel || 'search'}
          name={inputName || ''}
          value={inputValue}
          onChange={handleInputChange}
          onFocus={handleInputFocus}
          onKeyDown={handleKeyDown}
          onKeyUp={handleKeyUp}
        />
      </FeatureContainer>

      {isOpen && suggestions && suggestions.length > 0 && (
        <SuggestionsList
          suggestions={suggestions}
          styles={styles}
          focusedIndex={focusedIndex}
          inputValue={inputValue}
          textInputRef={textInputRef}
          wrapperRef={wrapperRef}
          setMenuRef={setMenuRef}
          onMenuClick={onMenuClick}
          handleMenuMouseEnter={handleMenuMouseEnter}
          handleMenuMouseLeave={handleMenuMouseLeave}
        />
      )}
      <FeatureContainer name="!homepageNewDesign">
        <button
          className={classnames(styles.button, styles[`-theme-${currentSite}`])}
          defaultValue="Submit"
          style={buttonStyle}
          onClick={() => reportAutoSuggest('Search bar')}
        >
          <SearchIcon />
        </button>
      </FeatureContainer>
      <FeatureContainer name="homepageNewDesign">
        <button
          className={classnames(styles.button, styles[`-theme-${currentSite}`])}
          defaultValue="Submit"
          onClick={() => reportAutoSuggest('Search bar')}
        >
          <SearchIcon />
          <span className={styles.searchText}>Search</span>
        </button>
      </FeatureContainer>
    </div>
  )
}

export default AutoSuggest
